export default "__VITE_ASSET__DSxlUk1C__"